import React from "react";
import { COLORS, TYPOGRAPHY, SPACING, RADIUS, TRANSITIONS, SHADOWS } from '../constants/designTokens';

const AboutUs = () => (
    <section id="about" className="aboutus-section py-5" style={{
        background: COLORS.background.lightBlue,
        position: "relative"
    }}>
        <style>{`
            .aboutus-section h2 {
                color: ${COLORS.primary.dark};
                font-weight: ${TYPOGRAPHY.fontWeight.bold};
                font-size: ${TYPOGRAPHY.fontSize['2xl']};
                margin-bottom: ${SPACING['2xl']};
                text-align: center;
                line-height: ${TYPOGRAPHY.lineHeight.tight};
            }
            .aboutus-quote {
                font-size: ${TYPOGRAPHY.fontSize.xl};
                font-style: italic;
                color: ${COLORS.primary.dark};
                text-align: center;
                margin-bottom: ${SPACING['2xl']};
                font-family: 'Georgia', serif;
                line-height: ${TYPOGRAPHY.lineHeight.relaxed};
                font-weight: ${TYPOGRAPHY.fontWeight.medium};
            }
            .aboutus-text {
                color: ${COLORS.text.primary};
                font-size: ${TYPOGRAPHY.fontSize.md};
                margin-bottom: ${SPACING.xl};
                line-height: ${TYPOGRAPHY.lineHeight.relaxed};
            }
            .aboutus-img {
                border-radius: ${RADIUS.xl};
                box-shadow: ${SHADOWS.lg};
                max-width: 100%;
                height: auto;
                transition: ${TRANSITIONS.all};
            }

            .aboutus-img:hover {
                transform: scale(1.05);
                box-shadow: ${SHADOWS.hover.lg};
            }
            @media (max-width: 767.98px) {
                .aboutus-section h2 {
                    font-size: ${TYPOGRAPHY.fontSize.xl};
                }
                .aboutus-quote {
                    font-size: ${TYPOGRAPHY.fontSize.md};
                }
                .aboutus-text {
                    font-size: ${TYPOGRAPHY.fontSize.base};
                }
            }
        `}</style>
        <div className="container">
            <h2>About Us</h2>
            <div className="aboutus-quote" style={{
                fontSize: TYPOGRAPHY.fontSize.xl,
                fontStyle: 'italic',
                color: COLORS.primary.dark,
                textAlign: 'center',
                marginBottom: SPACING['2xl'],
                fontFamily: 'Georgia, serif',
                lineHeight: TYPOGRAPHY.lineHeight.relaxed,
                fontWeight: TYPOGRAPHY.fontWeight.medium,
            }}>
                "Supplying vessels worldwide with certified, essential marine spare parts."
            </div>
            <div className="row align-items-center">
                <div className="col-lg-6 mb-4 mb-lg-0">
                    <div className="aboutus-text" style={{
                        color: COLORS.text.primary,
                        fontSize: TYPOGRAPHY.fontSize.md,
                        lineHeight: TYPOGRAPHY.lineHeight.relaxed,
                    }}>
                        Marine Sealink B.V. is dedicated to providing fast, reliable sourcing and supply of certified marine spare parts for the maritime industry. With years of experience and a passion for technical precision, our team ensures that vessels, crews, and operations stay fully equipped no matter where they are in the world.<br /><br />
                        Our mission is to minimize vessel downtime by providing essential electrical, instrumentation & control, OWS/ODME, and fire & smoke detection spare parts, offering tailored sourcing, expert technical part-identification, and MARPOL/SOLAS-compliant supply to empower our clients and keep them ahead in a rapidly evolving industry.
                    </div>
                </div>
                <div className="col-lg-6 text-center">
                    <figure style={{ margin: 0, display: "inline-block", maxWidth: "460px", width: "100%" }}>
                        <img src="/img/offshore-platform.jpg" alt="Offshore oil and gas platform at sea, the kind of installation Marine Sealink B.V. supplies spare parts for" className="aboutus-img" style={{
                            borderRadius: RADIUS.xl,
                            boxShadow: SHADOWS.lg,
                            width: "100%",
                            height: "auto",
                            transition: TRANSITIONS.all,
                        }} loading="lazy" />
                        <figcaption style={{
                            marginTop: SPACING.xs,
                            fontSize: TYPOGRAPHY.fontSize.xs,
                            color: COLORS.text.light,
                            lineHeight: TYPOGRAPHY.lineHeight.normal,
                        }}>
                            Photo: tsuda,{" "}
                            <a href="https://creativecommons.org/licenses/by-sa/2.0" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.text.light, textDecoration: "underline" }}>CC BY-SA 2.0</a>,{" "}
                            via{" "}
                            <a href="https://commons.wikimedia.org/wiki/File:Iwafune-oki_oil_platform_in_Japan.jpg" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.text.light, textDecoration: "underline" }}>Wikimedia Commons</a>
                        </figcaption>
                    </figure>
                </div>
            </div>
        </div>
    </section>
);

export default AboutUs;
